import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasFridge = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_fridge')(jsonQuery));
